import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'text',
    text: 'Tini mag den Park sehr gerne, sie findet es schön und nett dort. Es sind viele Spiele möglich. Der Türkenschanzpark ist ihr Lieblingspark, auch weil er sich unweit von ihrem Zuhause befindet. Er ist ihr somit sehr wichtig. Besonders gefällt ihr, dass man dort gut spazieren gehen kann und dass es einen Spielplatz gibt, auf welchem man klettern und rutschen kann. Auch eine Schaukel und eine Wippe befinden sich dort.'
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'dasproject-foto-tini-14_f1jupc',
    alt: 'dasProject Foto Tini',
    aspectRatio: 1.5
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'dasproject-foto-tini-11_idjrb0',
    alt: 'dasProject Foto Tini',
    aspectRatio: 1.5
  },
  {
    type: 'group',
    position: 'left',
    text: 'Sie findet es cool, mit dem Devilstick zu üben und zu spielen, macht dies in letzter Zeit jedoch eher selten. Vielleicht will sie mal wieder ihr Können mit dem Stick vorführen.',
    firstImg: {
      id: 'dasproject-foto-tini-16_pzywl4',
      alt: 'dasProject Foto Tini',
      aspectRatio: 1.5
    },
    secondImg: {
      id: 'dasproject-foto-tini-09_hp1hc8',
      alt: 'dasProject Foto Tini',
      aspectRatio: 1.5
    }
  },
  {
    type: 'text',
    text: 'Tini tanzt gern, sie bezeichnet es als ihr Lieblingshobby. Am liebsten tanzt sie zuhause zu ihrer Lieblingsmusik, zum Beispiel zu Shakira oder Lady Gaga. Tinis Firmpatin war auf einer Tanzschule. Sie ist Bauchtänzerin und hat ihr das Tuch zum Geburtstag geschenkt. Besonders gerne mag Tini den Hüftschwung mit dem Tuch, das scheppert so schön. Sie tanzt gerne mit dem Bauchtanztuch und hat dies an ihrem Geburtstag vor Cousins und Cousinen auch schon vorgeführt.'
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'dasproject-foto-tini-07_rx30rq',
    alt: 'dasProject Foto Tini',
    aspectRatio: 1.5
  }
]

const color = 'coral'

export default class ReactComponent extends React.Component {
  constructor(){
    super()
    this.state = {color: 'coral'}
  }

  render () {
    return (
      <div>
        <Person content={content} color={this.state.color} name='Tini' next={0} previous={7}/>
      </div>
    )
  }
}

exports.data = {
  color: 'coral',
  number: 9
}



// WEBPACK FOOTER //
// ./tini.js